/* eslint-disable import/no-anonymous-default-export */
import { Message } from './openai.service';
import HttpService from './http.service';

export interface ServiceRequest {
  serviceName: string;
  businessPrice: number;
  userId?: string;
  userName?: string;
  userProfileImage?: string;
  serviceDate?: string;
  categoryName?: string;
  companyName?: string;
  companyId?: string;
  conversationHistory?: Message[];
  cityName: string;
  userToken?: string;
  leadPrice?: number; // Precio por lead de la empresa
  UserPhone?: string; // Número de teléfono del usuario capturado del chat
}

export interface ServiceResponse {
  businessPrice: any;
  id: string;
  serviceId: string;
  serviceTitle: string;
  userId: string;
  userName: string;
  description: string;
  status: number; // 0 = Pending, 1 = In Progress, 2 = Completed
  completedDate: string | null;
  created: string;
  conversationHistory: {
    role: string;
    content: string;
    timestamp: string;
  }[];
  cityName: string;
  companyName: string;
  serviceDate: string;
  categoryName: string;
  userProfileImage: string;
  leadPrice: string;
  // Otros campos que pueda devolver la API
}

export interface MapServiceResponse {
  serviceDescription: string;
  categoryName: string;
  cityName: string;
}

class ServiceService {
  async createEnhancedService(serviceRequest: ServiceRequest): Promise<ServiceResponse> {
    try {
      const response = await HttpService.post<ServiceResponse>(
        '/api/ServiceRequests/ai',
        serviceRequest
      );

      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async getUserServiceRequests(userId: string): Promise<ServiceResponse[]> {
    try {
      const response = await HttpService.get<ServiceResponse[]>(
        `/api/ServiceRequests/user/${userId}`
      );

      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async getMapServiceData(query: string): Promise<MapServiceResponse> {
    try {
      const response = await HttpService.get<MapServiceResponse>(
        `/api/Services/map-service?query=${encodeURIComponent(query)}`
      );

      return response.data;
    } catch (error) {
      throw error;
    }
  }
}

//export default new ServiceService();
const serviceService = new ServiceService();
export default serviceService;
